import { ReactElement } from 'react';

import { IconWrapper, NotesIcon, Tooltip, TooltipLabel } from '@dreryk/react-components';

import { translationKeys } from '../../translations';

type NoteCellProps = {
   note: string;
};

export const NoteCell = (props: NoteCellProps): ReactElement => {
   return (
      <Tooltip
         testId={'note'}
         content={() => {
            return (
               <div>
                  <TooltipLabel label={translationKeys.entryNote} />
                  <span>{props.note}</span>
               </div>
            );
         }}
      >
         <IconWrapper testId={'note'}>
            <NotesIcon />
         </IconWrapper>
      </Tooltip>
   );
};
